import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import type { SetNewPasswordPayload } from 'services/requests';
import { yupPasswordFormat, yupRepeatPassword } from 'utils';
import type { UseCustomFormReturn } from './useCustomForm';
import { useCustomForm } from './useCustomForm';

export enum SetNewPasswordFieldNames {
  newPassword = 'newPassword',
  repeatNewPassword = 'repeatNewPassword',
}

export const useSetNewPasswordForm = (): UseCustomFormReturn<SetNewPasswordPayload> => {
  const schema: yup.SchemaOf<SetNewPasswordPayload> = yup.object({
    newPassword: yupPasswordFormat,
    repeatNewPassword: yupRepeatPassword('newPassword'),
  });

  const resolver = yupResolver(schema);
  const form = useForm<SetNewPasswordPayload>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  return useCustomForm(form, resolver);
};
